import * as GSAP from 'gsap';
import AbstractView = require("../abstract/AbstractView");
import TabItem = require("./TabItem");


class TabContainer extends AbstractView {

    constructor(template: JQuery) {
        super(template);
    }


    init(): void {
        // this.createContent();
    }

    resize(): void {
        if (this.$tabContentCon) {
            this.$tabContentCon.height(this.currentItem.$template.outerHeight());
        }
    }

    /*
    * TabContent
    * */
    private $tabContentCon: JQuery;
    private currentItem: TabItem;
    private tabItems: any[];

    public setItems(items: any[]): void {
        this.tabItems = items;
        this.createContent();
    }

    private createContent(): void {
        this.$tabContentCon = this.$template.find(".tabcontentCon");
        for (let i: number = 0; i < this.tabItems.length; i++) {
            let item: any = this.tabItems[i];
            item.emitter.on(TabItem.Events.ON_TRANSITION_IN_COMPLETE, this.onItemStatus.bind(this));
            item.emitter.on(TabItem.Events.ON_TRANSITION_OUT_COMPLETE, this.onItemStatus.bind(this));
        }
    }

    public changeTabItem(id: number): void {

        if (this.currentItem) {
            this.currentItem.transitionOut(id);
            return;
        }
        this.currentItem = <TabItem>this.tabItems[id];
        GSAP.TweenMax.to(this.$tabContentCon, 0.5, {
            css: {
                height: this.currentItem.$template.outerHeight()
            },
            ease: GSAP.Circ.easeInOut,
            onComplete: () => {
                this.currentItem.$template.addClass("active");
                this.currentItem.transitionIn();
            }
        });
    }

    private onItemStatus(params: any): void {

        if (params.type == TabItem.Events.ON_TRANSITION_IN_COMPLETE) {
            this.resize();
        }

        if (params.type == TabItem.Events.ON_TRANSITION_OUT_COMPLETE) {
            this.currentItem.$template.removeClass("active");
            this.currentItem = null;
            this.changeTabItem(params.id);
        }
    }


    onTransitionComplete(type: string, id?: number): void {
        if (type == AbstractView.Events.ON_TRANSITION_IN_COMPLETE) {
            this.currentItem.transitionIn();
            this.resize();
        }
        if (type == AbstractView.Events.ON_TRANSITION_OUT_COMPLETE) {
            this.currentItem.reset();
        }
        super.onTransitionComplete(type, id);
    }
}

export = TabContainer;